import Vue from 'vue';
import apm from '@common/plugin/apm.js';
import axios from 'axios';

/**
 * 缓动函数
 * @param {Number} start 起始位置
 * @param {Number} end 目标位置
 * @param {Number} rate 缓动速率
 * @param {Function} callback 变化的位置回调，支持两个参数，value和isEnding，表示当前的位置值（数值）以及是否动画结束了（布尔值）
 */
function animationEase(start, end, rate, callback) {

  if (start == end || typeof start != 'number') {
    return;
  }
  end = end || 0;
  rate = rate || 2;

  var step = function () {
    start = start + (end - start) / rate;

    if (Math.abs(end - start) < 1) {
      callback(end, true);
      return;
    }
    callback(start, false);
    requestAnimationFrame(step);
  };
  step();
}

/**
* 滚动到指定坐标点
* @param {DomElement} wrapEl 滚动容器
* @param {DomElement|Number} el 指定区域节点|指定位置
* @param {Number} startPosY 开始滚动的起始坐标
* @param {Function} finish 结束回调
*/
const scrollToEle = ({wrapEl, el, startPosY, scrollRate=5, finish}) => {
  if(!el) return
  var doc = wrapEl ? wrapEl : (document.body.scrollTop ? document.body : document.documentElement);
  var top = typeof el == 'number' ? el : el.offsetTop;
  var _scrollTop = startPosY != undefined ? startPosY : doc.scrollTop
  animationEase(_scrollTop, top, scrollRate, function (value, isEnd) {
    doc.scrollTop = value
    // if (doc.scrollTop == 0) {
    //   window.scrollTo(0, value)
    // } else {
    //   doc.scrollTop = value;
    // }
    if (isEnd) {
      finish && finish()
    }
  });
}

/**
* 对象转地址栏参数
* @param {Object} obj 对象
* @param {String} query 转成的地址参数串
*/
const queryStringify = function (obj, isEncode=true) {
  let query = '';
  for (let o in obj) {
    if (typeof obj[0] == 'object') {
      query += '&' + queryStringify(obj[o])
    } else {
      if(isEncode) {
        query += `&${o}=${encodeURI(encodeURI(obj[o]))}`
      } else {
        query += `&${o}=${(obj[o])}`
      }
    }
  }
  return query;
}

/**
 * 参数串转对象
 * @param String query 要转的参数字符串
 * @return Object 转换后的对象
 */
const parseQuery = function (query) {
  var reg = /([^=&\s]+)[=\s]*([^&\s]*)/g;
  var obj = {};
  while (reg.exec(query)) {
    obj[RegExp.$1] = RegExp.$2;
  }
  return obj;
}


const setHost = function (api) {
  //不是58测试环境，就需要去掉58的ip
  if (location.host !== '121.9.213.58') { api = api.replace('121.9.213.58/', ''); }
  // 接口测试环境处理
  if (window.location.host.indexOf('localhost') !== -1) {
    return api.replace('https://', 'http://121.9.213.58/');
  }
  if (window.location.host === '121.9.213.58') {
    return api.replace('https://', 'http://121.9.213.58/');
  } else {
    return api.replace('https://', window.location.protocol + '//');
  }
}

// 时间格式化
const formatDate = function (date, fmt) {
  let o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'S': date.getMilliseconds() // 毫秒
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  };
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)));
    }
  };
  return fmt;
}

/**
 * 获取随机颜色色值
 * @param {Number} index 指定色值的索引
 * @return {String} 色值
 */
const getRandomColor = function (index) {
  var array = [
    "#2ec7c9",
    "#b6a2de",
    "#5ab1ef",
    "#ffb980",
    "#d87a80",
    "#8d98b3",
    "#e5cf0d",
    "#97b552",
    "#95706d",
    "#dc69aa",
    "#07a2a4",
    "#9a7fd1",
    "#588dd5",
    "#f5994e",
    "#c05050",
    "#59678c",
    "#c9ab00",
    "#7eb00a",
    "#6f5553",
    "#c14089"
  ];
  var cur = Math.round(Math.random() * (array.length - 1));
  if (index !== undefined && index <= array.length - 1) {
    cur = index;
  }
  var value = array[cur]; //随机抽取一个值
  return value;
}

export {
  scrollToEle,
  queryStringify,
  parseQuery,
  setHost,
  formatDate,
  getRandomColor
}


// WEBPACK FOOTER //
// ./pc/index/utils/index.js